// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3c-dp","info":"Note_info__3cfXZ","note":"Note_note__zT7Ty","actions":"Note_actions__3YQj2"};